<script setup>
import { computed, onBeforeMount } from 'vue'
import { useProjectStore } from '@/stores/project'
import { useRoute } from 'vue-router'

import { FormProject } from '@/components/forms'
import { can } from '@/composables/useCan'
import ProjectCoverForm from './ProjectCoverForm.vue'

const projectStore = useProjectStore()
const route = useRoute()

const projectId = computed(() => parseInt(route.params.project_id))
const project = computed(() => projectStore.current)
const canEditCover = computed(() => !!project.value?.project_id && can('project', 'update', { projectId: project.value.project_id }))

onBeforeMount(async () => {
  await projectStore.fetchProject(projectId.value)
})
</script>

<template>
  <div>
    <div v-if="project">
      <FormProject :project="project" :key="project.project_id" :edit="true">
        <ProjectCoverForm :project="project" :disabled="!canEditCover" />
      </FormProject>
    </div>
    <div v-else>
      <p>Loading...</p>
    </div>
  </div>
</template>
